import React from 'react';
import ShowTotalToPayAmountProperties from "./ShowTotalToPayAmountProperties";
import {useStyles} from "./ShowTotalToPayAmount.style";
import {CurrencyModule} from "../../../util/Currency";
import {useI18nContext} from "../../../contexts/I18nContext";
import Currency from '../../../entities/Currency';

const ShowTotalToPayAmount: React.FC<ShowTotalToPayAmountProperties> = ({
                                                        totalToPay,
                                                        className = '',
                                                  }) => {

    const i18n = useI18nContext();
    const classes = useStyles();

    return (
        <div className={className}>
            <div className={classes.title}>{`${i18n.translate("TOTAL_TO_PAY")}:`}</div>
            <div className={classes.value}>{CurrencyModule.format(totalToPay, Currency.DOLLAR)}</div>
        </div>
    )
}

export default ShowTotalToPayAmount;